import React from 'react';
import AdminLogo from 'src/assets/images/Admin-logo.png';
import './style.scss';

interface IProps {}

export class AdminHeader extends React.Component<IProps> {
  render(): React.ReactNode {
    return (
      <div className="admin-header">
        <div className="admin-header__content">
          <div className="admin-header__logo">
            <img className="logo-icon" src={AdminLogo} alt={'logo'} />
          </div>
        </div>
      </div>
    );
  }
}
